import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import { StatusChip } from "@/shared/components/ui/Status/StatusChip";
import AccordianData from "./AccordianData";

const VALIDATION_CHIPS = {
  confirmed: {
    label: "Confirmed",
    variant: "lightBlue",
    tooltip: "A targeted search found a new source confirming this need.",
  },
  unconfirmed: {
    label: "Unconfirmed",
    variant: "neutral",
    tooltip: "No new source confirmed or refuted this yet. Verify the proof before pitching.",
  },
  refuted: {
    label: "Refuted",
    variant: "danger",
    tooltip: "A new source suggests this need is already met or no longer exists.",
  },
};

export default function CustomAccordion({ auditsData = [], userId, companyName }) {
  const [openItem, setOpenItem] = useState(null);

  const toggleItem = (id) => {
    setOpenItem((prev) => (prev === id ? null : id));
  };

  return (
    <div className="flex flex-col gap-2">
      {auditsData.map((item) => {
        const isOpen = openItem === item.id;
        const validation = VALIDATION_CHIPS[item?.validation_status] || VALIDATION_CHIPS.confirmed;

        return (
          <div
            key={item.id}
            className={`rounded-lg border transition-colors ${
              isOpen ? "border-secondary/40 bg-gray-50/60 dark:bg-gray-900/80" : "border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900"
            }`}
          >
            {/* HEADER */}
            <button
              onClick={() => toggleItem(item.id)}
              className="w-full flex items-center justify-between p-5 text-left relative cursor-pointer"
            >
              <span className="text-[0.793rem] font-medium leading-5 text-gray-800 dark:text-gray-100">
                {item.audit_title}
              </span>

              <div className="flex items-center gap-1.5">
                <StatusChip
                  label={validation.label}
                  variant={validation.variant}
                  tooltipContent={validation.tooltip}
                  tooltipPlacement={"left"}
                />
                <StatusChip
                  label={`${
                    item?.opportunity.charAt(0).toUpperCase() +
                    item?.opportunity.slice(1)
                  } Opportunity`}
                  variant={
                    item?.opportunity === "high"
                      ? "success"
                      : item?.opportunity === "medium"
                        ? "warning"
                        : "danger"
                  }
                  tooltipContent={item?.opportunity_score_reason}
                  tooltipPlacement={"left"}
                />
                {isOpen ? (
                  <ChevronUp size={20} className="text-gray-500" />
                ) : (
                  <ChevronDown size={20} className="text-gray-500" />
                )}
              </div>
            </button>

            {/* EXPANDING BORDER */}
            {isOpen && <div className="border-t border-gray-200 dark:border-gray-800" />}

            {/* CONTENT */}
            {/* grid-rows animates to the content's real height; a max-h cap clipped long cards */}
            <div
              className={`grid transition-all duration-300 ease-in-out ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <AccordianData data={item} userId={userId} companyName={companyName} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
